import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Widget } from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import './modal.css';
import { reenviar } from '@app/api/autorizacaoPagamento/autorizacao';

export interface propsModalReenviar {
  arquivoAutorizacaoId: string;
  setUpdate: any;
}

const ModalReenviar = (props: propsModalReenviar) => {
  const { arquivoAutorizacaoId, setUpdate } = props;
  const [exibirModal, setExibirModal] = useState(false);

  const handleSubmit = values => {
    reenviar(arquivoAutorizacaoId, values.justificativa).then(data => {
      if (data) {
        setExibirModal(false);
        setUpdate(null);
        setUpdate(true);
      }
    });
  };

  return (
    <>
      <Tooltip title="Reenviar">
        <Button
          onClick={() => {
            setExibirModal(true);
            // CarregarDados();
          }}
          icon="messaging-send_file"
          name="btnReenviar"
        />
      </Tooltip>
      <Modal
        title="Reenviar"
        // className="chat-modal"
        width="900px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formModal"
          onSubmit={handleSubmit}
          actions={[
            <Button
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton
              noIcon={true}
              type="primary"
              disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR'])}>
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <FormTextArea name="justificativa" label="Justificativa" span={12} rows={4} maxLength={2000} />
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};
export default ModalReenviar;
